<template>
  <v-container ma-0 pa-0 fluid>
    <v-title>Porting</v-title>
    <v-card>
      <v-card-text>
        <v-container fluid>
          <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
            <v-layout row wrap>
              <v-flex xs3>
                <v-layout wrap row>
                  <v-flex sm9 md8 lg8>
                    <vonex-text
                      ref="services"
                      v-model="NumberOfServicePorting"
                      :options="fieldConditions"
                      type="number"
                      name="services"
                      min="1"
                      :rule="'integer|min_value:0'"
                      label="Number of Services"
                      @keyup="changeRows"
                    />
                    <!-- <v-text-field
                    ref="services"
                    type="number"
                    name="services"
                    min="1"
                    v-model="NumberOfServicePorting"
                    @keyup="changeRows"
                    label="Number of Services"
                    />-->
                  </v-flex>
                  <v-flex sm2 md2 lg2>
                    <v-btn title="Add Row" class="iconBtn" @click="onAdd">
                      <v-icon>add</v-icon>
                    </v-btn>
                    <br />
                    <v-btn title="Remove Row" class="iconBtn" @click="onRemove">
                      <v-icon>remove</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-layout justify-end ma-0>
                <v-flex v-if="rows[0] && rows[0].pafID > 0" xs6>
                  <v-btn color="primary" @click="deleteFromOrder()">
                    Delete from {{ isQuote ? 'Quote' : 'Order' }}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-flex xs12>
                <h2>IP Porting Request</h2>
                <p>I wish to port the following:</p>

                <div class="table-responsive">
                  <table
                    class="table table-striped table-bordered mobile-table"
                  >
                    <thead>
                      <tr>
                        <th style="width: 3vw"></th>
                        <th>Category</th>
                        <th>
                          Service Number
                          <br />
                          or Start of Range
                        </th>
                        <th>Range</th>
                        <th>
                          Current Account
                          <br />
                          Number
                        </th>
                        <th>
                          Current Service
                          <br />
                          Provider
                        </th>
                        <th>Landing Point</th>
                        <th>Comment</th>
                        <th v-if="!isVisible">
                          White Pages
                          <br />
                          Listing
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(port, index) in rows" :key="index">
                        <td align="center">
                          <div v-show="port.pafID">
                            <v-icon color="green">check_circle</v-icon>
                            <v-icon @click="onRemove">delete</v-icon>
                          </div>
                        </td>
                        <td>
                          <vonex-select
                            v-model="port.category"
                            class="form-control custom-td"
                            :rule="'required'"
                            :name="'category' + index"
                            :items="category"
                            :options="fieldConditions"
                            hide-details
                          ></vonex-select>
                        </td>
                        <td>
                          <vonex-text
                            v-model="port.serviceNumber"
                            class="form-control custom-td"
                            :rule="isQuote ? '' : 'required'"
                            :options="fieldConditions"
                            :name="'serviceNumber' + index"
                            hide-details
                          />
                        </td>
                        <td>
                          <vonex-select
                            v-model="port.range"
                            class="form-control custom-td"
                            :options="fieldConditions"
                            :rule="port.category === 'C - Range' ? 'range' : ''"
                            :name="'range' + index"
                            hide-details
                            :items="getRange(port)"
                          ></vonex-select>
                        </td>
                        <td>
                          <vonex-text
                            v-model="port.accountNumber"
                            class="form-control custom-td"
                            :options="fieldConditions"
                            :rule="isQuote ? '' : 'required'"
                            :name="'accountNumber' + index"
                            hide-details
                          />
                        </td>
                        <td>
                          <vonex-text
                            v-model="port.currentServiceProvider"
                            class="form-control custom-td"
                            :rule="isQuote ? '' : 'required'"
                            :name="'currentServiceProvider' + index"
                            :options="fieldConditions"
                            hide-details
                          />
                        </td>
                        <td>
                          <vonex-text
                            v-model="port.landingPoint"
                            class="form-control custom-td"
                            :rule="isQuote ? '' : 'required'"
                            :name="'landingPoint' + index"
                            :options="fieldConditions"
                            hide-details
                          />
                        </td>
                        <td>
                          <vonex-text
                            v-model="port.comment"
                            class="form-control custom-td"
                            :name="'comment' + index"
                            :options="fieldConditions"
                            hide-details
                          />
                        </td>
                        <td>
                          <vonex-select
                            v-if="!isVisible"
                            v-model="port.whitePagesListing"
                            class="form-control custom-td"
                            :options="fieldConditions"
                            :rule="'required'"
                            :items="whitePagesOpts"
                            :name="'whitePagesListing' + index"
                            hide-details
                          ></vonex-select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <FileUploader :is-on-upload-page="true">Upload Previous Provider Invoice</FileUploader>
              </v-flex>
              <v-flex sm12 md12 lg12>
                <v-btn color="primary" name="sbmt" @click="submit">
                  Save Ports
                </v-btn>
                <message-alert :component="message"></message-alert>
              </v-flex>
            </v-layout>
          </ValidationObserver>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters, createNamespacedHelpers } from 'vuex';
import {
  mapPortingFields,
  mapPortingMultiRowFields,
} from '../store/modules/orders';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const { mapActions: mapPortingActions, mapMutations: mapPortingMutations } =
  createNamespacedHelpers(`orders/porting`);
import { httpError } from '../models/httpError';
import FileUploader from './FileUploader';
import Utils from '@/mixins/utils.mixin';
export default {
  name: 'CreatePorting',
  components: { FileUploader: FileUploader },
  mixins: [Utils],
  data() {
    return {
      isDataLoading: false,
      WhitePages: null,
      PhoneAccount: null,
      Port: false,
      whitePagesOpts: [
        { text: 'Yes', value: true },
        { text: 'No', value: false },
      ],
      category: [
        { text: 'A - Single', value: 'A - Single' },
        { text: 'C - Range', value: 'C - Range' },
      ],
      NumberOfServicePorting: 0,
      isVisible: true
    };
  },
  mounted() {
    let vm = this;
    this.$nextTick(async () => {
      vm.populatePorts().then(() => {
        if (vm.rows.length == 0) {
          vm.addRow();
        }
        vm.NumberOfServicePorting = vm.rows.length;
      });
    });
  },
  computed: {
    ...mapGetters('orders', ['isQuote']),
    ...mapOrderState({ order: 'rows' }),
    ...mapPortingMultiRowFields(['rows']),
    ...mapPortingFields(['message']),
  },
  methods: {
    ...mapPortingActions([
      'reset',
      'populatePorts',
      'setMessage',
      'removeRows',
      'updatePortsOnOrder',
      'addPortsOnOrder',
    ]),
    ...mapPortingMutations(['addRow', 'clearRows', 'deleteRow']),
    deleteFromOrder() {
      let vm = this;

      this.$dialog
        .confirm(
          'You are about to delete Porting data from this order, this cannot be undone, are you sure?'
        )
        .then(() => {
          vm.removeRows(0).then(() => {
            vm.$router.push('order-summary');
          });
        });
    },
    AddPort() {
      this.Port = !this.Port;
    },
    changeRows: function () {
      let vm = this;
      var oldVal = vm.rows.length;
      var newVal = vm.NumberOfServicePorting;
      //clearRows
      if (parseInt(oldVal, 10) > parseInt(newVal, 10)) {
        this.$dialog
          .confirm('You are about to delete rows, are you sure?')
          .then(function () {
            vm.removeRows(newVal)
              .then(function () {
                vm.NumberOfServicePorting = vm.rows.length;
              })
              .catch(function () {
                vm.NumberOfServicePorting = vm.rows.length;
              });
          })
          .catch(function () {
            //Clicked on cancel
            vm.NumberOfServicePorting = oldVal;
            return;
          });
      } else {
        if (newVal > vm.rows.length)
          for (var i = oldVal; i < newVal; i++) {
            vm.addRow();
          }
      }
    },
    removeRow(index) {
      let vm = this;
      vm.deleteRow(index);
      vm.NumberOfServicePorting = vm.rows.length;
    },
    onAdd() {
      this.NumberOfServicePorting++;
      this.$refs.services.$emit('keyup');
    },
    onRemove() {
      this.NumberOfServicePorting--;
      this.$refs.services.$emit('keyup');
    },
    submit() {
      let vm = this;
      vm.setMessage(new httpError());
      vm.$refs.observer
        .validate()
        .then(async (result) => {
          if (result) {
            try {
              //savePorts here
              vm.addPortsOnOrder();
            } catch (err) {
              vm.setMessage({ message: err.message, httpStatus: 500 });
            }
          } else {
            vm.setMessage({
              message: 'Unable to save: Check the highlighted fields above',
              httpStatus: 500,
            });
          }
        })
        .catch(function (err) {
          vm.setMessage({ message: err, httpStatus: 500 });
        });
    },
    getRange(data) {
      if (data.category == 'C - Range') return [10, 100];
      return [1];
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/custom-styles.scss';
</style>
